export default __webpack_public_path__ + "static/139-72b131bf021c1bc0d52b356eb7bb84f5.jpg";